import { useState } from "react";
import { executeAIAction } from "../AIActionButton/aiActionHandler";
import "./QuickReplyButtons.scss";

const QuickReplyButtons = ({ actions }: { actions: any[] }) => {
  const [consumed, setConsumed] = useState(false);

  if (!actions || actions.length === 0 || consumed) {
    return null;
  }

  const handleClick = (action: any) => {
    if (consumed) {
      return;
    }
    setConsumed(true);
    executeAIAction(action);
  };

  return (
    <div className="quick-reply-buttons">
      {actions.map((action, index) => (
        <button
          key={index}
          className="quick-reply-button"
          onClick={() => handleClick(action)}
          disabled={consumed}
        >
          {action?.actionButtonTitle}
        </button>
      ))}
    </div>
  );
};

export default QuickReplyButtons;
